import { BaseColor, theme } from '@prophecy/theme';
import { Badges } from '@prophecy/ui-v3/Badges';
import { Button } from '@prophecy/ui-v3/Button';
import { Ellipsis } from '@prophecy/ui-v3/Ellipsis';
import { Stack } from '@prophecy/ui-v3/Layout';
import { Text } from '@prophecy/ui-v3/Typography';
import styled from 'styled-components';

import { StyledMoreDetailsText } from './styled';
import { SQLPipelineRunStatus } from './types';

const StyledTooltipContainer = styled(Stack)`
  max-width: 400px;
`;

export function withEllipsis(text: string) {
  return (
    <Ellipsis tooltip>
      <Text level='sm'>{text}</Text>
    </Ellipsis>
  );
}

function StatusTooltip({ message, onExpandClick }: { message: string; onExpandClick?: () => void }) {
  return (
    <StyledTooltipContainer gap={theme.spaces.x6}>
      <Ellipsis>
        <Text level='sm'>{message}</Text>
      </Ellipsis>
      <Button variant='plain' onClick={onExpandClick} data-test-id='sql-pipeline-utils-error-details-button'>
        <StyledMoreDetailsText level='sm' weight={theme.fontWeight.bold}>
          More Details
        </StyledMoreDetailsText>
      </Button>
    </StyledTooltipContainer>
  );
}

export function getRunStatusBadge(runStatus: string, message?: string, onExpandMessageClick?: () => void) {
  if (runStatus === SQLPipelineRunStatus.SUCCEEDED) {
    return (
      <Badges variant='pillOutline' tone={BaseColor.success}>
        Success
      </Badges>
    );
  } else if (runStatus === SQLPipelineRunStatus.ERROR) {
    return (
      <Badges
        variant='pillOutline'
        tone={BaseColor.error}
        tooltip={message ? <StatusTooltip message={message} onExpandClick={onExpandMessageClick} /> : undefined}>
        Failed
      </Badges>
    );
  } else if (runStatus === SQLPipelineRunStatus.RUNNING) {
    return (
      <Badges variant='pillOutline' tone={BaseColor.gray}>
        Running
      </Badges>
    );
  } else if (runStatus === SQLPipelineRunStatus.WARNING) {
    return (
      <Badges
        variant='pillOutline'
        tone={BaseColor.warning}
        tooltip={message ? <StatusTooltip message={message} onExpandClick={onExpandMessageClick} /> : undefined}>
        Warning
      </Badges>
    );
  }
}
